// LLM-authored markdown can include arbitrary URLs (e.g. `<card url="...">`),
// so we only treat http(s) URLs as safe to render as links. Without this, a
// `javascript:` or `data:text/html` URL would execute
// attacker-controlled script when clicked (rel="noopener noreferrer" doesn't
// block scheme-based XSS, and these tags render under
// `dangerous-markdown-with-html` precisely because the surface trusts LLM output).
export function parseSafeHttpUrl(
  raw: string,
): { href: string; domain: string } | null {
  let parsed: URL;
  try {
    parsed = new URL(raw);
  } catch {
    return null;
  }
  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
    return null;
  }
  return {
    href: parsed.toString(),
    domain: parsed.hostname.replace(/^www\./, ""),
  };
}
